/**
 * @voltxampere/ui — TL072 dual JFET-input op-amp variant (Sprint 39-3)
 *
 * Datasheet-named op-amp preset. JFET-input low-noise audio op-amp,
 * 3 MHz GBW, 13 V/μs slew, picoamp input bias. ±15 V dual-rail typical.
 *
 * Reference: TI SLOS082K. Engine zero-diff invariant honored —
 * canonical "opamp" engine type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const opampTl072 = {
    id: "tl072",
    nameTr: "TL072 (FET-Girişli, DIP-8)",
    nameEn: "TL072 (FET-Input, DIP-8)",
    shortcut: "O",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "TL072",
    schemaType: "opamp",
    defaultParams: {
        openLoopGain: 2e5,
        saturationVoltage: 13,
        gainBandwidthProduct: 3e6,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=opamp-tl072.js.map